import axios from 'axios';
import ElementUI from 'element-ui'

let err403 = 0;

// Add a request interceptor
axios.defaults.params = {};
axios.interceptors.request.use(
   config => {
    if (process.env.NODE_ENV !== 'production') {
        config.params['orgMask'] = 'dJ22oOO';
    }
    return config;
  },
   error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const base = process.env.NODE_ENV === 'production' ? 'https://oa.casten.cn/api' : 'http://127.0.0.1:8001/api';

// 不需要登录
export const getClubNameByCode = params => { return axios.get(`${base}/club/name`, { params: params }); };

export const getGuildInviteInfoByPhone = params => { return axios.get(`${base}/anchor/getGuildInviteInfoByPhone`, { params: params }); };

export const getGuildInviteGeeStatus = params => { return axios.get(`${base}/anchor/getGuildInviteGeeStatus`, { params: params }); };

export const sendGuildInviteCode = params => { return axios.get(`${base}/anchor/sendGuildInviteCode`, { params: params }); };

export const validateGuildInviteCode = params => { return axios.get(`${base}/anchor/validateGuildInviteCode`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/api.js